<template>
    <v-row class="gap" justify="center">
        <v-col cols="12" sm="8" md="8" lg="6">
            <div class="question">{{question}}</div>
            <div class="small-text" v-html="helper_text"></div>
            <v-file-input 
                ref="fileinput"
                accept=".pdf"
                @change="inputAnswer" 
                :value="file"
                :clearable="false"
                :rules="required ? notEmpty : noRules"
                :label="'Click here to choose your file' + (required ? ' *' : '')">
            </v-file-input>
        </v-col>
    </v-row>
</template>
<script>
// import axios from 'axios'
import {upload} from '../client.js';
import Client from '../client.js';

export default {
    props: {
       question: String,
       answer: String,
       min_words: Number,
       max_words: Number,
       helper_text: String,
       required: Boolean,
       qid: String,
       aid: String,
       application_id: String,
       stageId: String,
    },
    computed: {
        file: {
            get() {
                if(!this.answer) return null;
                const name = this.answer.includes(`documents/`) ? this.answer.split(`documents/`)[1] : this.answer.split(`documents%2F`)[1];
                return new File([name], `${name}`, {type: 'text/plain'})
            },
            set() {
            }
        },
        rules() {
            return [v => {
                if(!this.required) return true;
                const val = v && v.trim();
                return val >= this.min_words && val <= this.max_words;
            }]
        },
        notEmpty() {
            return [v => {
                let hasAnswer = true;
                const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
                const currentQuestion = questionsWithAnswer[this.stageId] && questionsWithAnswer[this.stageId].find(item => item.Id === this.qid);
                if(!currentQuestion['Answer__c.Answer__c']) {
                    hasAnswer = false;
                }
                return Boolean(v) && hasAnswer;
            }]
        },
        noRules() {
            return [() => true]
        },
        existedAnswers() {
            const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
            if(!questionsWithAnswer[this.stageId]) return [];
            return questionsWithAnswer[this.stageId].map(item => item['Answer__c.Answer__c']);
        }
    },
    mounted() {
        setTimeout(() => {
            const el = this.$refs.fileinput.$el;
            const inputEl = el.querySelector('div.v-file-input__text');
            this.prevName = inputEl.innerText;
        }, 2000)
    },
    methods: {
        removeFilename() {
            setTimeout(() => {
                console.log('clear')
                const el = this.$refs.fileinput.$el;
                const inputEl = el.querySelector('div.v-file-input__text');
                inputEl.innerText = this.prevName;
            })
        },
        async inputAnswer(event) {
            // console.log('event: ', event)
            if(!event) {
                return;
            }
            if(event.type === 'text/plain') {
                return;
            }

                

            /*
            if(!/^[a-zA-Z0-9_.-]*$/.test(event.name)) {
                this.$alert('filename can only contain a-z, A-Z, 0-9, _ and -');
                this.removeFilename();
                return;
            }
            */
            if(this.checkDuplicate(event)) {
                this.$alert('Duplicate file');
                this.removeFilename();
                return;
            }
            console.log('upload')
            const tempFile = event;
            console.log('event');
            console.log(tempFile);
            console.log(tempFile.type);
            const type = tempFile.type;
            const size = tempFile.size;
            const newName = this.addDate() + '_' + this.profile.first_name + '_' + this.profile.last_name+ '.pdf';
            console.log('New Name ' + newName);
            console.log('Old event name  ' + event.name);
            let uploadFile = new File([tempFile],newName,{type,size});
            console.log('uploadFile');
            console.log(uploadFile);
            //let formData = new FormData() 
            //formData.append('file', uploadFile)

            this.prevName = tempFile.name;
            const el = this.$refs.fileinput.$el;
            const inputEl = el.querySelector('div.v-file-input__text');
            inputEl.innerText = this.prevName;
            this.file = event;
            const formData = new FormData();

            formData.append('file', uploadFile);
            if(this.aid) {
                formData.append('answerId', this.aid);
            }
            formData.append('prevAnswer', this.answer ? this.answer : '');
            try {
                this.$emit('upload-begin');
                const res = await upload(`/applications/${this.application_id}/documents/${this.qid}`, formData);
                this.$store.commit('stage/updateAnswer', {stageId: this.stageId, questionId: this.qid, answer: res.data[0].Answer__c, answerId: res.data[0].Id});
                this.$emit('upload-over');
                // this.$emit('on-answer', {qid: this.qid, answer: res.data[0].Answer__c, answerId: res.data[0].Id});
            } catch(e) {
                this.$emit('upload-over');
                this.$alert(e.response.data.message)
            }
        },
        checkDuplicate(event) {
            if(this.existedAnswers.some(item => item && (item.includes(event.name) || item.includes(this.fixedEncodeURIComponent(event.name))))) {
                return true;
            }
            return false;
        },
        fixedEncodeURIComponent(str) {
            return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
                return '%' + c.charCodeAt(0).toString(16);
            });
        },
        addDate(){
            
            //var _this = this;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth()+1;
            let dd = new Date().getDate()<10 ? '0' + new Date().getDate() : new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
            //_this.gettime = yy+mm+dd+hh+mf+ss;

            return '_'+yy+mm+dd+hh+mf+ss;
                    
        }
    },
    data: function() {
        return {
            prevName: '',
            profile: undefined,
        }
    },
    async beforeMount() {
        let client = Client();
        client.get('me/profile').then(res => {
            this.profile = res.data;
            console.log('me/profile'+res.data);
            console.log(res.data);
        }, () => {})      
    },
}
</script>
<style lang="scss" scoped>
.word-counts {
    margin-top: 10px;
    margin-bottom: 20px;
}
.small-text {
    font-family: $helper-font;
    font-size: 12px;
    line-height: 1.5;
}
.question {
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 1.25;
}
.gap {
    margin-bottom: 16px;
}
</style>
